import { Button, IconButton } from '@creditornot/cb-button';
import { Cross } from '@creditornot/cb-icons';
import { ModalContent, ModalFooter } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { WoltModal } from 'common/components';
import { Typography } from 'common/typography';

import { useBestOfWoltModal } from '../hooks/useBestOfWoltModal';
import YuhoStamp from '../images/YuhoStamp.png';

type IntroductionProps = {
  venue: Venue;
};

const IntroductionModalHeader = styled.div`
  background: linear-gradient(0deg, #00c2e8 0%, #00c2e8 100%);
  height: 300px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 18px;
  right: 18px;
`;

const IntroductionModalContent = styled(ModalContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  max-width: 620px;
`;

const IntroductionInfoContainer = styled.div`
  display: flex;
  padding: 48px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const IntroductionModalFooter = styled(ModalFooter)`
  display: flex;
  justify-content: flex-end;
`;

export const Introduction = ({ venue }: IntroductionProps) => {
  const { shouldShowModal, hideModal, navigateToBestOfWolt } = useBestOfWoltModal({
    key: 'best_of_wolt.intro',
    venue,
  });

  return (
    <WoltModal isOpen={shouldShowModal}>
      <IntroductionModalHeader>
        <img src={YuhoStamp} height={'100%'} />
        <CloseButton size="small" background="solid" variant="neutral" alignment="boundingBox" onClick={hideModal}>
          <Cross />
        </CloseButton>
      </IntroductionModalHeader>
      <IntroductionModalContent>
        <IntroductionInfoContainer>
          <Typography.Heading3>
            <FormattedMessage id="best-of-wolt.introduction.title" />
          </Typography.Heading3>
          <Typography.Body1>
            <p>
              <FormattedMessage id="best-of-wolt.introduction.description" />
            </p>
            <p>
              <FormattedMessage id="best-of-wolt.introduction.best-of-luck" />
            </p>
          </Typography.Body1>
        </IntroductionInfoContainer>
      </IntroductionModalContent>
      <IntroductionModalFooter>
        <Button variant="primary" size="small" onClick={() => navigateToBestOfWolt()}>
          <FormattedMessage id="best-of-wolt.introduction.learn" />
        </Button>
      </IntroductionModalFooter>
    </WoltModal>
  );
};
